<template>
    <div>
        <el-form :inline="true" :model="searchForm"  class="forTbFilter">
           <el-form-item label="所属代理商：">
                <el-select v-model="searchForm.agentId" filterable placeholder="请选择或输入关键字" clearable>
                    <el-option v-for="item in agentsOption" :value="item.agentId" :key="item.agentId" :label="item.agentName"></el-option>
                </el-select>
            </el-form-item>
             <el-form-item label="导入批次号：">
                <el-input v-model.trim="searchForm.importNum" @keyup.enter.native="getAgentOrderListHandle" clearable></el-input>
            </el-form-item>
             <el-form-item label="导入时间：" class="dateRange">
                <el-date-picker v-model="searchForm.time" range-separator="至" type="daterange" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
            <el-form-item class="btnArea">
                <el-button type="primary"  @click="getImportRecordListHandle">搜索查询</el-button>
                <el-button type="primary"  @click="getImportRecordListHandleExcels">导出数据</el-button>
            </el-form-item>
        </el-form>
        <el-button type="primary" class="onlyBtn" @click="showManyCardImport">批量导入</el-button>
        <el-table :data="tbpg.tableData" border height="611">
            <el-table-column prop="importTime" label="导入时间" width="150"></el-table-column>
            <el-table-column prop="importNum" label="导入批次" width="100"></el-table-column>
            <el-table-column prop="importTotal" label="导入张数（张）" width="120"></el-table-column>
            <el-table-column prop="importSuccess" label="导入成功张数（张）" width="150"></el-table-column>
            <el-table-column prop="importFail" label="导入失败张数（张）" width="150"></el-table-column>
            <el-table-column prop="agentName" label="代理商名称"></el-table-column>
            <el-table-column prop="supplierName" label="运营商" width="170"></el-table-column>
            <el-table-column prop="disposeName" label="操作人" ></el-table-column>
            <el-table-column label="操作" width="100">
                <template slot-scope="scope">
                    <el-button v-if="scope.row.importFail > 0" type="text" size="small" @click="getImportFailRecordListHandle(scope.row.id, $event)">查看失败</el-button>
                </template>
            </el-table-column>
        </el-table>   
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tbpg.currentPage"
            :page-sizes="[15, 50, 100, 500]"
            :page-size="tbpg.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tbpg.total">
        </el-pagination> 
        <el-dialog :title="title" :visible.sync="importCardVisible" width="600px" @close="cancel" :close-on-click-modal="false">
            <el-form ref="importCardForm" :model="importCardForm" :rules="importCardRules" label-width="100px">
                <el-form-item label="导入Excel：" prop="uploadExcel">
                    <el-upload ref="upload" :action="uploadUrl('sim/import/excel')" :headers="setHeader()" :limit="1" :auto-upload="false" :data="importCardForm" :on-change="handleChange" :on-success = "handleSuccess">
                        <el-button slot="trigger" plain>导入Excel</el-button>
                        <el-button style="margin-left: 10px;" plain @click="exportHandle()">导出模板</el-button>
                    </el-upload>                        
                </el-form-item>  
                <el-form-item label="卡类型：" prop="simType">
                    <el-radio-group v-model="importCardForm.simType">
                        <el-radio label="0">套餐卡</el-radio>
                        <el-radio label="1">流量池卡</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="是否语音卡：" prop="isVoice">
                    <el-radio-group v-model="importCardForm.isVoice">
                        <el-radio label="0">流量卡</el-radio>
                        <el-radio label="1">语音卡</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="卡片种类：" prop="cardCategory">
                    <el-radio-group v-model="importCardForm.cardCategory">
                        <el-radio label="MS">MS卡</el-radio>
                        <el-radio label="MP">MP卡</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item v-if="importCardForm.simType == 0" label="运营商：" prop="supplierId" >
                    <el-select v-model="importCardForm.supplierId" filterable placeholder="请选择或输入关键字">
                        <el-option v-for="item in supplierOption" :value="item.id" :key="item.id" :label="item.supplierName"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="代理商：" prop="agentId">
                    <el-select v-model="importCardForm.agentId" @change="changeAgent" filterable placeholder="请选择或输入关键字">
                        <el-option v-for="item in agentsOption" :value="item.id" :key="item.id" :label="item.name"></el-option>
                    </el-select>
                </el-form-item>          
                <el-form-item v-if="importCardForm.simType == 1" label="流量池：" prop="simPoolId">
                    <el-select v-model="importCardForm.simPoolId">
                        <el-option v-for="item in fluxPoolOption" :value="item.id" :key="item.poolName" :label="item.poolName"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="使用期限：" prop="simLife">
                    <el-row>
                        <el-col :span="22">
                            <el-input v-model="importCardForm.simLife"></el-input>
                        </el-col>
                        <el-col :span="2" class="center">月</el-col>
                    </el-row>
                </el-form-item>
                <el-form-item label="包年包月：" prop="isVoice">
                    <el-radio-group v-model="importCardForm.type">
                        <el-radio label="1">包月</el-radio>
                        <el-radio label="2">包年</el-radio>
                    </el-radio-group>
                </el-form-item>
                       <el-form-item label="SIM卡单价" prop="simPrice">
                    <el-row>
                        <el-col :span="22">
                            <el-input v-model="importCardForm.simPrice"></el-input>
                        </el-col>
                    </el-row>
                </el-form-item>
                <el-form-item label="语音群组ID" prop="voiceGroupId">
                    <el-row>
                        <el-col :span="22">
                            <el-input v-model="importCardForm.voiceGroupId"></el-input>
                        </el-col>
                    </el-row>
                </el-form-item>
          
                 <el-form-item label="自定义套餐组：" prop="agentId">
                    <el-select v-model="importCardForm.packageIdG" @change="changeAgentGroup" filterable placeholder="请选择或输入关键字">
                        <el-option v-for="item in packageOption" :value="item.id" :key="item.id" :label="item.name"></el-option>
                    </el-select>
                </el-form-item>  
                  <el-form-item label="套餐规格套餐：" prop="agentId">
                    <el-select v-model="importCardForm.packageId" filterable placeholder="请选择或输入关键字">
                        <el-option v-for="item in pkgsOption" :value="item.id" :key="item.id" :label="item.name"></el-option>
                    </el-select>
                </el-form-item>  
                   <el-form-item label="阈值设置" prop="limitData">
                    <el-row>
                        <el-col :span="22">
                            <el-input v-model="importCardForm.limitData"></el-input>
                        </el-col>
                    </el-row>
                </el-form-item>
                 <el-form-item label="卡板备注" prop="limitData">
                    <el-row>
                        <el-col :span="22">
                            <el-input v-model="importCardForm.remark"></el-input>
                        </el-col>
                    </el-row>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="sureImportCardHandle">确 定</el-button>
            </div> 
        </el-dialog> 
        <el-dialog title="导入失败卡列表" :visible.sync="importFailVisible" width="1000px" :close-on-click-modal="false">
            <el-table :data="tbpg_fail.tableData" border height="421">
                <el-table-column prop="iccid" label="ICCID号" width="200px"></el-table-column>
                <el-table-column prop="intoNo" label="接入号" width="200px"></el-table-column>
                <el-table-column prop="remark" label="错误描述"></el-table-column>
            </el-table>
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="tbpg_fail.currentPage"
                :page-sizes="[10, 50, 100, 500]"
                :page-size="tbpg_fail.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="tbpg_fail.total">
            </el-pagination>
        </el-dialog>
    </div>
</template>

<script>
import {oneCardImport, getImportRecordList, getImportFailRecordList} from '@/api/sim.js'
import {getPkgListPage, addPkg, updatePkg, getPkgDetail, changePkgState, adminPkgSort} from '@/api/package.js'
import common from '@/utils/common.js'
export default {
    data(){   
        var checkImportFile = (rule, value, callback) => {
            var files = this.$refs.upload.uploadFiles
            var len = files.length;
            if(len > 0){
                var extName = files[0].name.split('.')[1].toLowerCase();
                if(extName != 'xls' && extName != 'xlsx'){
                    return callback(new Error('请选择要导入的Excel文件'));
                }else{
                    callback();
                }
            }else{
                return callback(new Error('请选择要导入的Excel文件'))
            }           
        }
        return {  
            agentsOption:[],
            searchForm:{
                agentId:'',
                importNum:'',
                time:''
            },          
            agentAccountForm: {
                name: '',
                sysUserAccountName: '',
                accountState: ''
            },
            importCardForm: {
                simType: '0',
                cardCategory: 'MP',
                supplierId: '',
                agentId: '',
                simPoolId: '',
                simLife: '',
                isVoice:'',
                packageId:null,
                packageIdG:null,
                simPrice:'',
                voiceGroupId:'',
                type:2,
                limitData:'',
                remark:'',
            },
            importCardVisible: false,
            importFailVisible: false,
            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0
            },
            tbpg_fail: {
                tableData: [],
                currentPage: 1,
                pageSize: 10,
                total: 0
            },       
            currentId_fail: '',
            pkgsOption:[],
            supplierOption: [],
            packageOption: [],
            agentsOption: [],
            fluxPoolOption: [],
            title: '',
            importCardRules: {
                uploadExcel: [{required: true, validator: checkImportFile}],
                iccid: [{required: true, validator: this.checkIccid, trigger: 'blur'}],
                intoNo: [{required: true, validator: this.checkIntoNo, trigger: 'blur'}],
                supplierCode: [{required: true, message: '请选择供应商', trigger: 'change'}],
                basePkgGroup: [{required: true, message: '请选择套餐组', trigger: 'change'}],
                cardType: [{required: true, message: '请选择卡类型', trigger: 'change'}]
            }
        }
    },
    methods: {
        cancel(){            
            this.importCardVisible = false; 
            this.$refs.importCardForm.resetFields();
        },
        handleChange(file, fileList){
            if(fileList.length > 0){
                this.$refs.importCardForm.fields[0].clearValidate();
            }
        },
        getImportRecordListHandle($event){
            common.resetCurrentPage(this, $event, 'tbpg');
            var data = common.getRequestParams(this, 'tbpg', this.searchForm);
            getImportRecordList(data).then(res => {
                common.listCallback(this, res, 'tbpg');
            })
        },
        getImportRecordListHandleExcels($event){
            common.resetCurrentPage(this, $event, 'tbpg');
            var data = common.getRequestParams(this, 'tbpg', this.searchForm);
            this.exportExcel("/sim/other/batch/select/sim/import", data);
        },
        getImportFailRecordListHandle(id, $event){
            this.importFailVisible = true;
            this.currentId_fail = id;
            var searchForm = {
                id: this.currentId_fail
            }
            common.resetCurrentPage(this, $event, 'tbpg_fail');
            var data = common.getRequestParams(this, 'tbpg_fail', searchForm);
            getImportFailRecordList(data).then(res => {
                common.listCallback(this, res, 'tbpg_fail');
            })
        },
        showManyCardImport(){
            this.getOptionsOfSelect();
            this.importCardVisible = true;
            this.title = "批量导入";
        },
        getOptionsOfSelect(){       
            common.getSupplierOptsCom(this, 'supplierOption');    
            common.getNextAgentOptsCom(this, 'agentsOption');    
            common.getPackageOptsCom (this,'packageOption') 
        },
        changeAgent(){
            this.importCardForm.simPoolId = '';
            var data = {
                id: this.importCardForm.agentId
            }
            common.getFluxPoolOptsCom(this, 'fluxPoolOption', data)
        },
        changeAgentGroup(){
             var voicePkg = {
                typeGroupId: this.importCardForm.packageIdG,
                isVoice:0
            }
            getPkgListPage(voicePkg).then(res => {
                this.pkgsOption =res.data.data.resultList;
                console.log(this.pkgsOption)         
            })
        },
        sureImportCardHandle(){
            this.$refs.importCardForm.validate(valid => {
                if(valid){
                    this.$refs.upload.submit();   //号段批量导入
                }
            })           
        },
        exportHandle(){//导出excel文件
            var data = {};
            data.token = localStorage.getItem('token');
            this.exportExcel('/excel/sim/template', data);
            this.$message.success('下载中……');
        },
        handleSuccess(res){
            if(res.code == 200){
                this.importCardVisible = false;
                this.getImportRecordListHandle();
                this.$refs.upload.clearFiles();
                this.$message.success(res.message);
            }else{
                this.$message.error(res.message);
            }
        },
        handleSizeChange(val){
            if(this.importFailVisible){
                this.tbpg_fail.pageSize = val;
                this.getImportFailRecordListHandle(this.currentId_fail);
            }else{
                this.tbpg.pageSize = val;
                this.getImportRecordListHandle();
            }
        },
        handleCurrentChange(val){
            if(this.importFailVisible){
                this.tbpg_fail.currentPage = val;
                this.getImportFailRecordListHandle(this.currentId_fail);
            }else{
                this.tbpg.currentPage = val;
                this.getImportRecordListHandle();
            }
        }  
    },
    created () {
        this.getImportRecordListHandle();
         common.sysRequest('/agent/listOption', {}, 'post').then(res => {
            if(res.data.code == 200){
                this.agentsOption = res.data.data;
            }

        });
    } 
}
</script>

<style lang="less" scoped>

</style>

